import React from "react";
import LoginForm from "../../components/auth/LoginForm.component";
import authBg from "../../assets/images/auth/BG.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Auth.styles.css";
import ChatHelp from "../../components/chat-help/ChatHelp.component";
import { useTranslation } from "react-i18next";
import MetaComp from "../../components/meta-comp/MetaComp.component";
import LegalLinks from "../../components/auth/LegalLinks.component";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import MfaForm from "../../components/auth/MfaForm.component";
import { useDispatch } from "react-redux";
import { LOGIN } from "../../redux/actions/actions.types";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { apiErrorHandler } from "../../utils/errorHandler";
import i18next from "i18next";
import { getApiUrl } from "../../utils/apiUrls";
import instance from "../../utils/axios";
import { changeLang } from "../../redux/actions/appSettings.actions";
import { replaceDynamicString } from "../../utils/helperFn";
import useWindowSize from "../../hooks/useWindowSize";
import AccountLock from "./AccountLock.page";
import moment from "moment/moment";
import PendingConsent from '../../components/auth/PendingConsent.component';
import ReCAPTCHA from 'react-google-recaptcha';

const allowedIncorrectPassword = 6
const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const getLang = searchParams.get("lang");
  const windowSize = useWindowSize();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refId = searchParams.get("refId");
  const clientData = useSelector((state) => state.clientData);
  const env = useSelector((state) => state?.env);
  const recaptchaRef = React.useRef(null);

  const [mfadata, setMfadata] = React.useState({
    viaEmail: false,
    viaAuthenticator: false,
    defaultAuthenticationTypeFlag: false,
    emailId: null,
    qrIsSet: false,
    type: "",
    otp: Array(6).fill(""),
    otpHasErrorMsg: "",
    originalAuthenticationType: "",
    isBackButtonStr: "",
    backButtonHistory: {
      type: "",
      defaultAuthenticationTypeFlag: "",
    },
  });
  const [showErrorCount, setShowErrorCount] = React.useState(null);
  const [isCrfShown, setIsCrfShown] = React.useState({ status: false, data: null });
  const [isLoading, setIsLoading] = React.useState(false);
  const showErrorHandler = () => {
    setShowErrorCount(null);
  };

  const captchaWidget = React.useMemo(() => {
    if(env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
      return (
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={env?.RECAPTCHA?.SITE_KEY}
          size="invisible"
          className="cm-recaptcha"
        />
      )
    }
    return null;
  }, [env?.RECAPTCHA?.ENABLE_RECAPTCHA])

  const authenticationTypeValue = () => {
    if (mfadata.viaAuthenticator && mfadata.viaEmail) {
      return "EMAIL_AND_AUTHENTICATION_APP";
    } else if (mfadata.viaEmail) {
      return "EMAIL";
    } else {
      return "AUTHENTICATION_APP";
    }
  };
  const skipForNowHandler = () => {
    loginHandler(
      {
        authenticationType: null,
        username: mfadata.emailId,
      },
      1
    );
  };

  const actionHandler = (val = null) => {
    if (val === "RESEND_OTP") {
      loginHandler(
        {
          authenticationType: "EMAIL",
          username: mfadata.emailId,
          resend: true,
        },
        2,
        null,
        "RESEND_OTP"
      );

      return;
    }
    const passCode = Number(
      mfadata.otp[0] +
        mfadata.otp[1] +
        mfadata.otp[2] +
        mfadata.otp[3] +
        mfadata.otp[4] +
        mfadata.otp[5]
    );
    switch (mfadata.type) {
      case "FIRST_TIME_LOGIN":
        loginHandler(
          {
            authenticationType: authenticationTypeValue(),
            username: mfadata.emailId,
          },
          1
        );
        break;
      case "FIRST_STEP":
        loginHandler(
          {
            username: mfadata.emailId,
            defaultAuthentication: mfadata.defaultAuthenticationTypeFlag,
            authenticationType: mfadata.viaEmail
              ? "EMAIL"
              : "AUTHENTICATION_APP",
          },
          2,
          {
            type: mfadata.viaEmail ? "SECOND_STEP_EMAIL" : "SECOND_STEP_APP",
          }
        );
        break;
      case "SECOND_STEP_EMAIL":
        if (passCode.toString().length !== 6) {
          setMfadata({
            ...mfadata,
            otpHasErrorMsg: "opt_should_have_six_number",
          });
          return;
        }
        loginHandler(
          {
            actionType: "EMAIL",
            username: mfadata.emailId,
            passCode: Number(passCode),
          },
          3
        );
        break;
      case "SECOND_STEP_APP":
        if (passCode.toString().length !== 6) {
          setMfadata({
            ...mfadata,
            otpHasErrorMsg: "opt_should_have_six_number",
          });
          return;
        }
        loginHandler(
          {
            actionType: "AUTHENTICATION_APP",
            username: mfadata.emailId,
            passCode: Number(passCode),
          },
          3
        );
        break;
      default: return null
    }
  };
  const mfadataHandler = (val) => {
    setMfadata({ ...mfadata, ...val });
  };
  const saveUser = async (jwtToken, lang) => {
    setIsLoading(false);
    const decodedData = jwtDecode(jwtToken);

    localStorage.setItem("token", jwtToken);

    if (!!lang) {
      const res = await instance.post(`${getApiUrl("saveLanguage")}/${lang}`);

      if (res.data.statusCode === "SUCCESS") {
        dispatch(changeLang(lang));
        i18next.changeLanguage(lang);
      }
    } else {
      const res = await instance.get(`${getApiUrl("getLastLanguageUsed")}`);

      dispatch(changeLang(!!res.data ? res.data : "en"));
      i18next.changeLanguage(!!res.data ? res.data : "en");
    }

    dispatch({
      type: LOGIN,
      payload: JSON.parse(decodedData.sub),
    });
    return;
  };

  const handleBackToLogin = () => {
    setIsCrfShown({ status: false, data: null });
    setMfadata({
      viaEmail: false,
      viaAuthenticator: false,
      defaultAuthenticationTypeFlag: false,
      emailId: null,
      qrIsSet: false,
      type: "",
      otp: Array(6).fill(""),
      otpHasErrorMsg: "",
      originalAuthenticationType: "",
      isBackButtonStr: "",
      backButtonHistory: {
        type: "",
        defaultAuthenticationTypeFlag: "",
      },
    });
  }

  const loginHandler = async (
    data,
    stepper,
    appendMfaData = null,
    actionType
  ) => {
    try {
      if (isLoading) return;

      let recaptchaToken = null;
      if (stepper === 0 && env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
        recaptchaToken = await recaptchaRef.current.executeAsync();
        if (!recaptchaToken) {
          dispatch(openSnackBar({ msg: t('captcha_verification_failed'), type: 'error' }));
          return;
        }
      }

      setIsLoading(true);
      const loginData = await axios.post(
        `${getApiUrl("login")}?stepper=${stepper}`,
        { ...data, refId, getLang, mettlClientName: clientData?.clientName, ...(mfadata?.skid ? {skid: mfadata?.skid} : {}), ...(mfadata?.password ? {password: mfadata?.password} : {}), ...(stepper === 0 ? { recaptchaToken } : {}) }
      );
      const dataToAdd = {
        ...(data?.skid ? { skid: data.skid } : {}),
        ...(data?.password ? { password: data.password } : {}),
      }
      if (loginData.data?.jwtToken) {
        if (!!getLang) {
          saveUser(loginData.data?.jwtToken, getLang);
        } else {
          saveUser(loginData.data?.jwtToken, null);
        }
      } else if(loginData.data?.jwtToken === null) {
        setIsCrfShown({ status: true, data: { ...data, refId, getLang, mettlClientName: clientData?.clientName } });
      } else if (stepper === 0) {
        // WHEN USER WRITE EMAIL AND PASSWORD
        let type;
        let temp = {};
        if (loginData.data.authenticationType === null) {
          type = "FIRST_TIME_LOGIN";
        } else if (
          loginData.data.authenticationType === "EMAIL" ||
          loginData.data.defaultAuthenticationType === "EMAIL"
        ) {
          loginHandler(
            {
              defaultAuthentication:
                !!loginData?.data?.defaultAuthenticationType,
              authenticationType: "EMAIL",
              username: data.username,
              ...dataToAdd
            },
            2
          );
          temp = { viaEmail: true };
          type = "SECOND_STEP_EMAIL";
        } else if (
          loginData.data.authenticationType === "AUTHENTICATION_APP" ||
          loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
        ) {
          temp = { viaAuthenticator: true };
          type = "SECOND_STEP_APP";
        } else if (
          loginData.data.authenticationType === "EMAIL_AND_AUTHENTICATION_APP"
        ) {
          type = "FIRST_STEP";
        }
        if (loginData.data.defaultAuthenticationType === "EMAIL") {
          temp = { viaEmail: true };
        } else if (
          loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
        ) {
          temp = { viaAuthenticator: true };
        }
        setMfadata(prevState => {
          return {
          ...prevState,
          ...dataToAdd,
          mfaDate: loginData.data.mfaDate,
          defaultAuthenticationType: loginData.data.defaultAuthenticationType,
          defaultAuthenticationTypeFlag:
            !!loginData.data.defaultAuthenticationType,
          originalAuthenticationType: loginData.data.authenticationType,
          emailId: data.username,
          candidateId: loginData.data.candidateId,
          type,
          ...temp,
        }
        });
      }
      if (stepper === 2) {
        if (!!appendMfaData) {
          setMfadata({
            ...mfadata,
            ...appendMfaData,
          });
        } else if (actionType === "RESEND_OTP") {
          dispatch(
            openSnackBar({
              msg: t("resend_otp_send_sucessfully"),
              type: "success",
            })
          );
        }
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const errObj = apiErrorHandler(err);
      if (stepper === 0) {
        if (errObj.statusText === "account_not_activated") {
          dispatch(
            openSnackBar({
              msg: t("account_not_activated"),
              type: "error",
            })
          );
          return;
        } else if (err.response?.data?.inCorrectCount > allowedIncorrectPassword - 1) {
          setMfadata({
            ...mfadata,
            type: "ACCOUNT_LOCK",
          });
          return;
        } else if (err.response?.data?.inCorrectCount > 0) {
          setShowErrorCount(err.response?.data?.inCorrectCount);
          dispatch(
            openSnackBar({
              msg: replaceDynamicString(
                t("incorrect_details_entered_you_only_more_attempt"),
                [allowedIncorrectPassword - err.response?.data?.inCorrectCount]
              ),
              type: "error",
            })
          );
          return;
        }
      } else if (stepper === 3 && errObj.statusText === "otp_invalid") {
        setMfadata({
          ...mfadata,
          otpHasErrorMsg: "invalid_passcode_please_try_again",
        });
        dispatch(
          openSnackBar({
            msg: t("invalid_passcode_please_try_again"),
            type: "error",
          })
        );
        return;
      } else if (errObj.statusText === "otp_already_send") {
        dispatch(
          openSnackBar({
            msg: t("resend_otp_send_sucessfully"),
            type: "success",
          })
        );
        return;
      }
      if (err.response?.data?.status === 401) {
        dispatch(
          openSnackBar({
            msg: t(err.response.data.details[0]),
            type: "error",
          })
        );
      } else {
        dispatch(
          openSnackBar({
            msg: t(errObj.statusText),
            type: "error",
          })
        );
      }
    } finally {
      recaptchaRef.current?.reset();
    }
  };
  const subTextHandler = () => {
    if (!!mfadata?.type && mfadata.type === "FIRST_TIME_LOGIN") {
      return t("choose_set_multi_factor_authentication");
    }
    if (
      !!mfadata?.type &&
      (mfadata.type === "SECOND_STEP_EMAIL" ||
        mfadata.type === "SECOND_STEP_APP" ||
        mfadata.type === "FIRST_STEP")
    ) {
      return t("mfa_verification_method");
    }
    return t("login_into_your_account");
  };
  if (mfadata.type !== "ACCOUNT_LOCK")
    return (
      <main className="cm-page-container cm-auth-page-container d-flex row mx-0">
        <MetaComp title={t("login_page_title")} />
        {
          isCrfShown.status ? <PendingConsent t={t} data={isCrfShown.data} loginHandler={loginHandler} handleBackToLogin={handleBackToLogin} /> 
          : 
          <>
            <div className="col-sm-12 col-md-6  cm-auth-content-wrap d-flex flex-column">
              <div className="cm-auth-content-inner col-12 flex-grow-1 d-flex flex-column justify-content-center">
                <div>
                  <div className="cm-txt-wrap d-flex flex-column">
                    <h2 className="h2 text-blue-gray-700 cm-fs-24 cm-mmc-font">
                      {t("welcome_login")}
                      <span
                        className={`d-block h1 text-primary fw-bold ${
                          windowSize.isMobile ? "cm-fs-24" : "cm-fs-40"
                        }`}
                      >
                        {clientData?.clientName
                          ? clientData?.clientName
                          : t("candidate_side_app_name")}
                      </span>
                    </h2>
                    <h4 className="h4 text-blue-800 mb-0">{subTextHandler()}</h4>
                    {mfadata.type === "FIRST_TIME_LOGIN" &&
                      !moment().isAfter(mfadata.mfaDate * 1000) && (
                        <div className="d-flex me-auto px-3 cm-xs-txt mt-4 py-1 text-white bg-action-1 cm-btn-radius">
                          <FontAwesomeIcon
                            icon={regular("Exclamation-circle")}
                            className="my-auto"
                          />
                          <p className="ms-2 mb-0 fw-medium">
                            {replaceDynamicString(
                              t("adding_mfa_will_be_mandatory_by_date"),
                              [moment(mfadata.mfaDate * 1000).format("MMM DD YYYY")]
                            )}
                          </p>
                        </div>
                      )}
                  </div>

                  <hr className="cm-auth-hr bg-blue-gray-300" />

                  {!mfadata?.type ? (
                    <LoginForm
                      showErrorHandler={showErrorHandler}
                      loginHandler={loginHandler}
                      getLang={getLang}
                      showErrorCount={showErrorCount}
                      isParentLoading={isLoading}
                    />
                  ) : (
                    <MfaForm
                      actionHandler={actionHandler}
                      mfadata={mfadata}
                      mfadataHandler={mfadataHandler}
                      skipForNowHandler={skipForNowHandler}
                    />
                  )}
                </div>
              </div>
              <LegalLinks />
            </div>
            <div
              className="col-sm-6 py-8 cm-auth-bg-container position-relative d-none d-lg-block d-md-block w-md-50"
              style={{ backgroundImage: `url('${authBg}')` }}
            >
              <ChatHelp />
            </div>
          </>
        }
        {captchaWidget}
      </main>
    );
  return <AccountLock t={t} refId={refId} />;
};

export default LoginPage;
